import type { FC } from 'react';

import Info from '@crehana/compass.icons.outline/Info';

import { StudioCourseConfigStateEnum } from '@/shared/types/graphql/globals.v5';

import useTeamCoursesTranslation from '../../../hooks/useTeamCoursesTranslation';
import type { TInformation } from '../../../types';
import Divider from './Divider';

const InformationTablet: FC<TInformation> = ({
  title,
  duration,
  labelTrack,
  isRequired,
  visibilityState,
}) => {
  const { t } = useTeamCoursesTranslation();

  const isHiddenCourse = visibilityState === StudioCourseConfigStateEnum.HIDDEN;

  return (
    <>
      {isHiddenCourse ? (
        <div className="tw-w-full sm:tw-my-auto">
          <div className="tw-flex tw-flex-col tw-w-full">
            <p className="tw-line-clamp-1 tw-font-subtitle5 tw-mb-0.4 tw-text-neutral-light-800 dark:tw-text-neutral-light-100">
              {t('COURSE_VISIBILITY_STATE_HIDDEN_TITLE')}
            </p>
            <div className="tw-w-fit tw-flex tw-items-center tw-gap-0.4 tw-px-0.8 tw-py-0.4 tw-rounded-0.4 tw-bg-on-hold-400">
              <Info size={16} className="tw-text-neutral-light-100" />
              <p className="tw-font-caption tw-text-neutral-light-100">
                {t('COURSE_VISIBILITY_STATE_HIDDEN_SUBTITLE')}
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div className="tw-w-full sm:tw-my-auto">
          <div className="tw-flex tw-items-center tw-w-full">
            <p className="tw-line-clamp-1 tw-font-subtitle5 tw-mb-0.4 tw-text-neutral-light-800 dark:tw-text-neutral-light-100">
              {title}
            </p>
            <p className="tw-ml-0.8 tw-font-label1 tw-text-neutral-light-600 tw-uppercase tw-mr-0.8 tw-shrink-0 ">
              {labelTrack}
            </p>
          </div>

          <div className=" tw-mb-1 sm:tw-mb-0 tw-flex tw-items-center tw-w-full tw-text-neutral-light-700 dark:tw-text-neutral-dark-400 tw-font-body5">
            {isRequired && (
              <>
                <span className="tw-flex-shrink-0 tw-text-primary-light-500">
                  {t('TAG_REQUIRED')}
                </span>
                {duration && <Divider />}
              </>
            )}
            {duration && (
              <span className="tw-flex-shrink-0 tw-mr-0.8">{duration}</span>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default InformationTablet;
